// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatAnswerError-moduleanswerError__OlgO3";
var _2 = "GretaAIChatAnswerError-modulecritical__W3ex_";
var _3 = "GretaAIChatAnswerError-modulecriticalText__wtvxc GretaAIChatAnswerError-moduletext__sNq1Z Text-moduletext__Z2j5F";
var _4 = "GretaAIChatAnswerError-modulegapped__MNlPz";
var _5 = "GretaAIChatAnswerError-moduleicon__hpAXi";
var _6 = "GretaAIChatAnswerError-moduleretry__cmdBy";
var _7 = "GretaAIChatAnswerError-moduletext__sNq1Z Text-moduletext__Z2j5F";
export { _1 as "answerError", _2 as "critical", _3 as "criticalText", _4 as "gapped", _5 as "icon", _6 as "retry", _7 as "text" }
